module.exports = __webpack_public_path__ + "img/ITI-DD.f354b524.png";